import React from 'react'
import Navbar from '../components/shared/Navbar'
import Footer from '../components/shared/Footer'
import HomeBody from '../components/home/HomeBody'

const Home = () => {
  return (
    <div>
      <Navbar></Navbar>
      <HomeBody></HomeBody>
      <Footer></Footer>
    </div>
  )
}

export default Home
